<template>
    <div class="about-wrapper">
        <div class="content-wrapper">
            <div class="content-profile-title-section">
                <hr class="hr-text" />
                    <h4>Din</h4>
                    <h1 class="content-profile-title">Brukerkonto</h1>
            </div>
            <div class="content-profile-wrapper">
                <div class="content-profile-section">
                    <ul class="profile-select">
                        <li>
                            <button @click="currentView = 'PersonalInfoBonusView'">
                                <a-icon style="margin-right: 1rem;" type="user" />
                                <span>Personlig info</span>
                            </button>
                        </li>
                        <li>
                            <button @click="currentView = 'TransactionHistory'">
                                <a-icon style="margin-right: 1rem;" type="history" />
                                <span>Ordrehistorikk</span>
                            </button>
                        </li>
                        <li>
                            <button @click="currentView = 'MyFavorites'">
                                <a-icon style="margin-right: 1rem;" type="star" />
                                <span>Mine favoritter</span>
                            </button>
                        </li>
                        <li>
                            <button>
                                <a-icon style="margin-right: 1rem;" type="logout" />
                                <span>Logg ut </span>
                            </button>
                        </li>
                    </ul>
  
                    <transition
                        :duration="{ enter: 300, leave: 500 }"
                        name="fade"
                        mode="out-in"
                    >
                        <component :is="currentView" key="currentView" />
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import TransactionHistory from "../../views/userAccount/TransactionHistory.vue";
import MyFavorites from "../../views/userAccount/MyFavorites.vue";
import PersonalInfoBonusView from "../../views/userAccount/PersonalInfoBonusView.vue";

export default {
    components: { TransactionHistory, MyFavorites, PersonalInfoBonusView },
    data() {
      return { currentView: "PersonalInfoBonusView" };
    }
  };
</script>
  
<style lang="scss" scoped>
  $desktop: 1200px;
  $laptop: 1024px;
  $tablet: 768px;
  $mobile: 480px;
  span {
    position: relative;
  }
  span::before {
    content: "";
    position: absolute;
    width: 115%;
    height: 3px;
    border-radius: 4px;
    background-color: #18272f;
    bottom: 12px;
    left: -13px;
    transform-origin: right;
    transform: scaleX(0);
    transition: transform 0.5s ease-in-out;
  }
  
  span:hover::before {
    transform-origin: left;
    transform: scaleX(1);
  }
  button {
    background-color: transparent;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .bonus-section {
    margin-top: 1rem;
    text-align: center;
    font-size: 1.2rem;
    font-weight: bolder;
    color: #d44541;
  }
  .hr-text {
    line-height: 1em;
    position: relative;
    outline: 0;
    border: 0;
    color: black;
    text-align: center;
    height: 1.5em;
    opacity: 0.5;
    &:before {
      content: "";
      // use the linear-gradient for the fading effect
      // use a solid background color for a solid bar
      background: linear-gradient(to right, transparent, #818078, transparent);
      position: absolute;
      left: 0;
      top: 50%;
      width: 100%;
      height: 1px;
    }
    &:after {
      content: attr(data-content);
      position: relative;
      display: inline-block;
      color: black;
  
      padding: 0 0.5em;
      line-height: 1.5em;
      // this is really the only tricky part, you need to specify the background color of the container element...
      color: #818078;
      background-color: #fcfcfa;
    }
  }
  .sub-info-container {
    display: flex;
    font-size: 1.2rem;
  }
  .profile-phonenumber {
    margin-left: 0.5rem;
  }
  
  .bonus-section,
  .profile-email,
  .profile-phonenumber {
    border: 2px solid #f0f2f5;
    border-radius: 5px;
    padding: 0.5rem;
  }
  .profile-section {
    margin-left: 8rem;
  }
  .profile-name {
    font-size: 2rem;
    font-weight: 600;
    margin: 1rem;
  
    padding: 1rem;
  }
  .profile-select {
    font-size: 1.5rem;
    font-family: Quicksand, sans-serif;
    font-weight: bold;
    padding-left: 15rem;
    white-space: nowrap;
  
    & li {
      margin: 1.5rem;
  
      list-style-type: none;
    }
  }
  
  .content-wrapper {
    margin: 0;
    font-family: Quicksand, sans-serif;
    overflow: hidden;
  
    @media (max-width: $mobile) {
      margin: 0;
    }
  }
  
  .content-profile-title-section {
    margin-bottom: 80px;
  }
  .content-profile-title {
    margin-bottom: 6rem;
    text-align: center;
    text-transform: uppercase;
    font-size: 58px !important;
    font-family: Bebas, sans-serif;
    font-weight: 400 !important;
  }
  .content-profile-section {
    display: flex;
  }
  h4 {
    text-align: center;
    font-family: Roboto, sans-serif;
    font-weight: 400 !important;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: #878787;
    position: relative;
    top: 25px;
    @media (max-width: $mobile) {
      font-size: 1em;
      top: 10px;
    }
  }
</style>
  